<template>
  <div class="Page">
    <HeaderSection 
      title="Project Aanmelden"
      :closeLinkTo="{ name: 'home' }">
    </HeaderSection>

    <ContentSection 
      class="ContentSection--aanmelden"
      wide 
      grow>
      <iframe  
        src="https://airtable.com/embed/shr0uJmLZE2A2WUTq?backgroundColor=green" 
        frameborder="0" onmousewheel="" 
        style="background: transparent"></iframe>
    </ContentSection>
  </div>
</template>

<script>
import ContentSection from '@/components/section/ContentSection';
import HeaderSection from '@/components/section/HeaderSection';

export default {
  name: 'PageProjectAanmaken',
  components: {
    HeaderSection,
    ContentSection
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.dispatch('extended_set', { extended: true })
    })
  },
  beforeRouteLeave (to, from, next) {
    this.$store.dispatch('extended_set', { extended: false })
    next();
  },
}
</script>

<style lang="scss">
.Page {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #fafafa; // Same as AirTable iframe... 

  .ContentSection--aanmelden {
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;

    &:before {
      position: absolute;
      content: 'Het formulier wordt geladen...';
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-content: center;
      align-items: center;
      justify-content: center;
      font-family: $font_nav;
    }

    iframe {
      flex-grow: 1;
      width: 100%;
      z-index: 1;
      opacity: 0.99;
    }
  }
}
</style>
